<template>
  <v-hover v-slot="data">
    <v-card :to="to">
      <v-img
        v-if="item.Image"
        :class="hover && data.hover ? 'hover-zoom hover-zoom-active' : 'hover-zoom'"
        :height="imageHeight"
        :src="item.Image"
      />

      <v-container fluid>
        <v-row class="align-center">
          <v-col cols="12">
            <v-card-title
              v-if="item.Name"
              :class="{'pb-0': !item.Desc}"
              class="px-0 pt-0"
            >
              <div
                class="overflow-hidden text-no-wrap"
                style="text-overflow: ellipsis;"
              >
                {{ item.Name }}
              </div>
            </v-card-title>

            <v-card-subtitle
              v-if="item.Desc"
              class="px-0 pb-0"
            >
              <div
                class="overflow-hidden text-no-wrap"
                style="text-overflow: ellipsis;"
              >
                {{ item.Desc }}
              </div>
            </v-card-subtitle>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-hover>
</template>

<script>
import CategoryCardMixin from '@/theme/default/views/home/CategoryCard.js'

export default {
  name  : 'CategoryCard',
  mixins: [CategoryCardMixin]
}
</script>

<style scoped src="@/theme/default/views/home/CategoryCard.css"></style>
<style scoped>
</style>
